
import { AppRoutes } from "./app-routes.enum";

export class RouteHistoryItem {
    CurrentRoute: string
    Url: string;
    PageTitle: string;
    
}